import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { toast } from "react-toastify";

dayjs.extend(customParseFormat);

export const preventNegativeValues = (event) => {
  const { value } = event.target;

  // Allow only positive numbers (including empty value for user input flexibility)
  if (value === "" || /^[0-9]*$/.test(value)) {
    event.target.value = value; // Ensuring the value stays valid
  } 
  else {
    event.target.value = value.replace(/[^0-9]/g, "");
  }
};
// const parseDate = (date) => {

  export const parseDate = (date) => {
  // if (!date) return dayjs(null);
  if (!date) return null;
  if (dayjs.isDayjs(date)) return date;

  // Try common formats used in the app
  // const formats = ["DD-MM-YYYY", "DD/MM/YYYY", "YYYY-MM-DD", "YYYY/MM/DD"];
  const formats = [
    "YYYY-MM-DD",
    "DD-MM-YYYY",
    "DD/MM/YYYY",
    "YYYY/MM/DD",
    "YYYY-MM-DD HH:mm:ss",
    "DD-MM-YYYY HH:mm:ss",
  ];
  // for (const format of formats) {
  //   const parsed = dayjs(date, format);

    for (const fmt of formats) {
    const parsed = dayjs(date, fmt, true);
    if (parsed.isValid()) return parsed;
  }
  
  // Fallback to default parsing
  // return dayjs(date);
  const fallback = dayjs(date);
  return fallback;
};

export const validateEndDate = (startDate, endDate) => {
  // const start = startDate ? dayjs(startDate, "DD-MM-YYYY") : null;
  // const end = endDate ? dayjs(endDate, "DD-MM-YYYY") : null;

  if (!startDate || !endDate) return true;
  const start = parseDate(startDate);
  const end = parseDate(endDate);

  // if (end && start && end.isBefore(start)) {
    if (end.isValid() && start.isValid() && end.isBefore(start, "day")) {
    toast.error("End Date (Due Date) must be greater than Start Date");
    return false;
  }
  return true;
};

export const validateStartDate = (startDate, endDate) => {
  if (!startDate || !endDate) return true;

  const start = parseDate(startDate);
  const end = parseDate(endDate);

  if (start.isValid() && end.isValid() && start.isAfter(end, "day")) {
    toast.error("Start Date must be less than or equal to Due Date");
    return false;
  }
  return true;
};

// onKeyDown for whole-number fields (amounts, rates): only digits and the editing keys get through,
// so "-", "+", "e" and "." never appear. Shortcuts (Ctrl/Cmd + V, A, C ...) still work; whatever is
// pasted is cleaned by the field's onChange (see preventNegativeValues).
const EDITING_KEYS = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Home", "End", "Delete", "Enter"];
export const blockNonDigitKeys = (event) => {
  if (event.ctrlKey || event.metaKey) return;
  if (!/^[0-9]$/.test(event.key) && !EDITING_KEYS.includes(event.key)) {
    event.preventDefault();
  }
};

export const allowPositiveDecimals = (event) => {
  let { value } = event.target;

  if (value === "" || /^\d*\.?\d*$/.test(value)) {
    event.target.value = value;
  }
   else {
    const cleanedValue = value
      .replace(/[^0-9.]/g, "") // Remove non-digit and non-dot
      .replace(/(\..*)\./g, "$1"); // Keep only the first dot
    event.target.value = cleanedValue;
  }
};
